// schema
import { Day, Maybe } from "@clockwise/schema";

import moment from "moment-timezone";
import { ZonedMoment } from "@util/time-zone.util";
import { calDateRange } from "@state/local-storage";

import { maybeShowMinutes, prettyTimeRange } from "@clockwise/client-commons/src/util/date";
export { maybeShowMinutes, prettyTimeRange };

////////////////////////
// SIMPLE HELPERS
///////////////////////
export function isDateDayEnum(date: Date | string, day?: Maybe<Day>) {
  return day === moment(date).format("dddd");
}

export function isSameWeek(date0: ZonedMoment, date1: ZonedMoment): boolean {
  const startOfWeek0 = date0.startOf("day").startOf("week");
  const startOfWeek1 = date1.startOf("day").startOf("week");

  return startOfWeek0.isSame(startOfWeek1);
}

////////////////////////
// FORMATTING
///////////////////////
export function convertDateStringToMoment(dateString: string) {
  return moment.utc(dateString, "YYYY-MM-DD");
}

export function getFormattedTime(start: ZonedMoment, end: ZonedMoment, isSingleLine = false) {
  const formattedStart = maybeShowMinutes(start);
  const formattedEnd = maybeShowMinutes(end);
  if (isSingleLine) {
    return `${formattedStart} - `;
  }
  return `${formattedStart} \u2013 ${formattedEnd}`;
}

export function formatMinutesToHours(minutes: number, showHalfHour = true) {
  if (showHalfHour) {
    return Math.round(minutes / 30) / 2;
  }
  // otherwise this is pretty uninteresting
  return Math.round(minutes / 60);
}

////////////////////////
// RANGES
///////////////////////
export function getCalDateFromPath(location: Location) {
  // ensure there is a calDateRange in the url
  let calDateRangeHint = "";
  const pathParts = location.pathname.split("/");
  if (pathParts.length >= 3) {
    calDateRangeHint = pathParts[2];
  }
  return calDateRangeHint;
}

export function getCalDateRange(pathHint: string) {
  // use moment here instead of ZonedMoment because we just want the beginning of the week
  // not adjusted for timezones
  let calMoment = moment(pathHint);
  const storedCalDateRange = calDateRange.get();
  if (!calMoment.isValid() && storedCalDateRange) {
    calMoment = moment(storedCalDateRange);
  }
  if (!calMoment.isValid()) {
    calMoment = moment();
  }
  return calMoment.startOf("day").startOf("week").format("YYYYMMDD");
}

export function generateWeekOfDateStrings(date: Date | ZonedMoment | string) {
  const start = new ZonedMoment(date).startOf("day").startOf("week");
  return [...Array(7)].map((_x, i) => {
    return start.clone().add(i, "days").format("YYYY-MM-DD");
  });
}
